import React, { useRef, useState } from "react";
import "./index.css";
import { Button, TextField } from "@mui/material";
// import debounce from './Debounce';
import axios from "axios";
import ChildComment from "../ChildComment";

export default function Comment(props) {
  const { handleAlert, model, project, user } = props;
  const [comment, setComment] = useState("");
  const [replyTo, setReplyTo] = useState(null);
  const [reload, setReload] = useState(false);
  const textRef = useRef(null);

  const inputFocus = () => {
    textRef.current.focus();
  };

  const handleInputChange = (e) => {
    setComment(e.target.value);
  };

  const handleCancel = () => {
    setReplyTo(null);
  };

  const onSend = () => {
    if (comment.length < 10) {
      handleAlert("error", "Comment should be more than 10 letters!", 3000);
    } else if (user.id === -1) {
      handleAlert("error", "Guest users are not allowed to comment!", 3000);
    } else {
      axios({
        method: "post",
        url: `/api/m2d/comments/addComment`,
        data: {
          comment: comment,
          replyTo: replyTo ? replyTo.cid : null,
          uid: user.id,
          mid: model ? model.id : null,
          pid: project ? project.id : null,
          imgs: null,
        },
      })
        .then(() => {
          // window.location.reload(false)
          setComment("");
          setReload(!reload);
          handleAlert("success", "Comment sent successfully!");
        })
        .catch((err) => {
          console.log(err);
          handleAlert("error", err, 3500);
        });
    }
  };

  return (
    <>
      <div className="comment-content">
        <div className="top-comment-bar">
          <TextField
            placeholder={!user || user.id === -1 ? "Want to make some comments? Sign up for an account!" : (replyTo ? `Reply to: @${replyTo.username}` : "")}
            minRows={2}
            maxRows={5}
            multiline
            value={comment}
            inputRef={textRef}
            onChange={handleInputChange}
            sx={{
              marginRight: "10px",
              width: "100%",
              backgroundColor: "white",
              borderRadius: "8px",
            }}
            disabled={!user || user.id === -1 ? true : false}
          />
          <div className="top-comment-btn-area">
            <Button
              variant="contained"
              style={{ marginBottom: "8px" }}
              onClick={onSend}
              disabled={!user || user.id === -1 ? true : false}
            >
              Send
            </Button>
            <Button
              variant="outlined"
              disabled={!user || user.id === -1 ? true : (replyTo ? false : true)}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </div>

        <div className="comment-area">
          <ChildComment
            parentComment={{ id: -1 }}
            model={model}
            project={project}
            user={user}
            setReplyTo={setReplyTo}
            mentionFocus={inputFocus}
            parentReload={reload}
            handleAlert={handleAlert}
          />
        </div>
      </div>
    </>
  );
}
